import { observer } from "mobx-react";
import { RadioButton } from "../../../components/inputs/radio-button/radio-button";
import Translation from "../../../translation/translation";
import FontBody2 from "../../../components/fonts/font-body2/font-body2";
import { FONT_COLOR } from "../../../components/fonts/font-props";
import "./yes-no-c-rma-fuq-answer.scss";
import CreateRmaFuqStore from "../stores/create-rma-fuq-store";
import CreateRmaFuqAnswerStore from "../stores/create-rma-fuq-answer-store";
import useTranslation from "../../../translation/hooks/translation-hook";


interface YesNoFuqQuestionProps {
    question: CreateRmaFuqStore;
}

const YesNoCRmaFuqAnswer: React.FC<YesNoFuqQuestionProps> = observer(({question}) => {

    const { getTranslation } = useTranslation();

    const handelSelect = (answer: CreateRmaFuqAnswerStore) => {
        question.resetAllAnswersSelections();
        question.setSelectedAnswer(answer, getTranslation);
    }

    return(
        <>
            {question.answers.map( (answer) => {
                return (
                    <div key={answer.id} className="yes-no-c-rma-fuq-answer">
                        <RadioButton 
                            name={`yes_no_fuq_radio_button_${question.id}`}
                            checked={answer.isSelected}
                            onChange={() => handelSelect(answer)}
                        />
                        <Translation Font={FontBody2} color={FONT_COLOR.PRIMARY2} translationKey={answer.displayName} />
                    </div>
                );
            })}
        </>
        
    );
      

});
export default YesNoCRmaFuqAnswer;